import { ChangeEvent, useEffect, useRef, useState } from "react";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { FerramentasDeDetalhe, RadioGroup, CheckBox, ILstLiga } from "../../shered/components";
import { VForm, VTextField, VScope, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { IDetalheUsuario, UsuarioService } from "../../shered/services/api/usuario/UsuarioService";
import { useAppThemeContext } from "../../shered/contexts";
import {
    Box, Button, FormControl, Icon, InputLabel, MenuItem, Paper, Select, TextField, Typography, useTheme
} from "@mui/material";
import Grid from '@mui/material/Grid2';

import { EstadoService } from "../../shered/services/api/estado/EstadoService";
import { CidadeService } from "../../shered/services/api/cidade/CidadeService";
import { PaisService } from "../../shered/services/api/pais/PaisService";
import { useAuthContext } from "../../shered/contexts";
import { VInput } from "../../shered/forms/VInput";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { Loading } from "../../shered/components/loading/Loading";
import { VInputCurrency } from "../../shered/forms/VInputCurrency";
import { VTextFieldDatas } from "../../shered/forms/VTextFieldDatas";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { ILstDrop, maskCNPJEvent, maskCPFEvent, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { LigaService } from "../../shered/services/api/liga/LigaService";
import { FranquiaService } from "../../shered/services/api/franquia/FranquiaService";
import { useCookies } from "react-cookie";
import dayjs from "dayjs";

//dados do insert de usuario
const sexoItens = [
    { codigo: 1, label: 'Masculino' },
    { codigo: 2, label: 'Feminino' },
    { codigo: 3, label: 'Outros' }
];

const formValidationSchema = yup.object<IDetalheUsuario>().shape({

    nome: yup.string().required("Campo obrigatório").min(3, "O campo deve ter mais que 3 caracteres"),
    ativo: yup.boolean().default(true).required("Campo obrigatório"),
    residencia_Exterior: yup.boolean().default(false).required("Campo obrigatório"),
    cgcCnpj: yup.string().when("residencia_Exterior", { is: false, then: (schema) => schema.required("Campo obrigatório"), otherwise: (schema) => schema.notRequired() }),
    email: yup.string().required().email("Campo obrigatório"),
    dddCel: yup.string().required("Campo obrigatório"), //.matches(dddPhoneNumber);
    celular: yup.string().required("Campo obrigatório"), //.matches(phoneNumber);
    sexo: yup.number().required("Campo obrigatório"),
    dtNascimento: yup.date().required("Campo obrigatório"),
    //codigo_Liga_Favorito: yup.number().moreThan(0, "Campo obrigatório").required("Campo obrigatório"),
    endereco: yup.object().shape({
        cep: yup.string().required("Campo obrigatório"),
        tipoLogradouro: yup.string().required("Campo obrigatório"),
        logradouro: yup.string().required("Campo obrigatório"),
        numero: yup.string().required("Campo obrigatório"),
        bairro: yup.string().required("Campo obrigatório"),
        codPais: yup.number().moreThan(0, "Campo obrigatório").required("Campo obrigatório"),
        codEstado: yup.number().moreThan(0, "Campo obrigatório").required("Campo obrigatório"),
        codCidade: yup.number().moreThan(0, "Campo obrigatório").required("Campo obrigatório"),
    }),
    login: yup.string().required().min(4, "O campo deve ter mais que 4 caracteres"),
    senha: yup.string().required().min(3, "O campo deve ter mais que 3 caracteres"),
    confirmarSenha: yup.string().default("").oneOf([yup.ref('senha')], 'Senha não confere'),
    permiteEnvioEmail: yup.boolean().default(true),
    permiteEnvioWhatsApp: yup.boolean().default(true),
    administrador: yup.boolean().default(false),
    desconto_Comissario: yup.boolean().default(false),
    desconto_Indicacao: yup.boolean().default(false),


});

type TOptions = {
    codigo: number;
    label: string;
}

export interface IDadosImagemPerfil {
    imageFile: File | null;
    Imagem: string;
    SrcImagem: string | ArrayBuffer | null | undefined;
}

export const DetalheDeUsuarios: React.FC = () => {
    const user = CookieService.get("access_user");
    const { id = 'novo' } = useParams<"id">(); //Recebe Parametro de tipagem
    const [isLoading, setIsLoading] = useState(false);
    const [nome, setNome] = useState("");
    const [ativo, setAtivo] = useState(true);
    const [residenciaExterior, setResidenciaExterior] = useState(true);

    const [administrador, setAdministrador] = useState(true);
    const [descontoComissario, setDescontoComissario] = useState(false);
    const [indicacao, setIndicacao] = useState(false);
    const [podeIndicar, setPodeIndicar] = useState(false);
    
    const [codigoUsuarioIndicacao, setCodigoUsuarioIndicacao] = useState(0);
    const [edicao, setEdicao] = useState(false);
    let codLocal = localStorage.getItem("@codigoLiga");
    const [opcoesEstado, setOpcoesEstado] = useState<TOptions[]>([]);
    const [opcoesCidades, setOpcoesCidades] = useState<TOptions[]>([]);
    const [opcoesPais, setOpcoesPais] = useState<TOptions[]>([]);
    const [cookies, setCookie, removeCookie] = useCookies();
    const [opcoesTimeFavorito, setOpcoesTimeFavorito] = useState<ILstDrop[]>([]);

    const [codigo_Liga_Favorito, setCodigo_Liga_Favorito] = useState(0);
    const [codigoFranquiaNBA, setCodigoFranquiaNBA] = useState(0);
    const [codigoTimeFutebolFavorito, setCodigoTimeFutebolFavorito] = useState(0);

    const { themeName } = useAppThemeContext();
    const navigate = useNavigate();
    const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
    const { logout } = useAuthContext();
    const [adm, setAdm] = useState(false);
    const [cod_Usuario, setCod_Usuario] = useState(0);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [codPais, setCodPais] = useState(0);
    const [codEstado, setCodEstado] = useState(0);
    const [codCidade, setCodCidade] = useState(0);
    const [mensagem, setMensagem] = useState("");
    const [caminhoImagem, setCaminhoImagem] = useState("public/empty.png");
    const [imagemPerfil, setImagemPerfil] = useState<any | null>("");
    const [showImagemPerfil, setShowImagemPerfil] = useState<any | null>("");
    const [dadosImg, setDadosImg] = useState<IDadosImagemPerfil>();
    const [lstLiga, setLstLiga] = useState<ILstLiga[]>([]);
    const [lstFranquiasNBA, setLstFranquiasNBA] = useState<ILstDrop[]>([]);
    const [redirecionar, setRedirecionar] = useState("0");
    const [cep, setCep] = useState("");
    const [cpfCnpj, setCpfCnpj] = useState("");
    const [documento, setDocumento] = useState("");


    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    let alterouFoto = false;


    useEffect(() => {
        const user = CookieService.get("access_user");
        setAdm(user.administrador);
        setCod_Usuario(user.codUsuario);
        const fetchData = async () => {
            await EstadoService.getAll()
                .then((result) => {
                    // setIsLoading(false);
                    // setRemoveLoading(true);                  
                    const est = result.data.dado;
                    setOpcoesEstado(est.sort((a, b) => a.nome > b.nome ? 1 : -1).map(est => ({ codigo: est.codigo, label: est.nome })));

                }).catch((errors) => {
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível carregar os dados da usuário! Favor entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                });

            await PaisService.getAll()
                .then((result) => {
                    setIsLoading(false);
                    setRemoveLoading(true);
                    const est = result.data.dado;
                    setOpcoesPais(est.sort((a, b) => a.nome > b.nome ? 1 : -1).map(est => ({ codigo: est.codigo, label: est.nome })));

                }).catch((errors) => {
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível carregar os dados da usuário! Favor entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                });

            await FranquiaService.getFranquiaNBA()
                .then(result => {
                    let lstFranquiaNBA = result.dado.map((f, i) => ({ codigo: f.codigo, label: f.nome === null ? `Franquia ${i + 1} ` : f.nome }));
                    setLstFranquiasNBA(lstFranquiaNBA);
                }).catch((errors) => {
                    setRemoveLoading(true);
                    setIsLoading(false);
                    if (errors.response.data.statusHTTP === 401) {
                        setShowModalMensagem(true);
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                });

            UtilidadeService.getListaTimesFutebol()
                .then(result => {
                    const list = result.dado.sort((a, b) => Number(new Date(b.nome)) - Number(new Date(a.nome))).map(l => ({ codigo: l.codigo, label: l.nome }));
                    setOpcoesTimeFavorito(list);
                }).catch((errors) => {
                    setIsLoading(false);
                    if (errors.response.data.statusHTTP === 401) {
                        setShowModalMensagem(true);
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                });

            if (id !== "novo") {
                const resultCrypt = UtilidadeService.decrypt(id);
                if (resultCrypt === "" || resultCrypt === undefined) {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    setIsLoading(false);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Dados inválidos! ",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;

                }

                setEdicao(true);
                setIsLoading(true);
                setRemoveLoading(false);
                carregarLigasDoUsuario(Number(resultCrypt));
                await UsuarioService.getById(Number(resultCrypt))
                    .then((result) => {
                        setIsLoading(false);
                        setRemoveLoading(true);
                        const usu = result.dado;
                        setNome(`${usu.nome} ${usu.sobrenome}`);
                        formRef.current?.setData(usu);
                        formRef.current?.setFieldValue("endereco", usu.endereco);
                        formRef.current?.setFieldValue("endereco.codPais", usu.endereco?.codPais);
                        setCpfCnpj(usu.cgcCnpj);
                        setDocumento(usu.documento);
                        formRef.current?.setFieldValue("confirmarSenha", usu.senha);
                        formRef.current?.setFieldValue("imagemPerfil", usu.imagemPerfil);
                        setShowImagemPerfil(usu.caminho_Imagem_Perfil === null ? "../../semimagem.png" : usu.caminho_Imagem_Perfil);
                        setCodPais(usu.endereco?.codPais ? usu.endereco?.codPais : 1);
                        setCodEstado(usu.endereco?.codEstado ? usu.endereco?.codEstado : 0);
                        setCodCidade(usu.endereco?.codCidade ? usu.endereco?.codCidade : 0);
                        setCep(usu.endereco?.cep ?? "");
                        setCodigo_Liga_Favorito(usu.codigo_Liga_Favorito);
                        setCodigoTimeFutebolFavorito(usu.codigo_Time_Futebol_Favorito ? usu.codigo_Time_Futebol_Favorito : 0);
                        setCodigoFranquiaNBA(usu.codigo_Franquia_NBA_Favorito ? usu.codigo_Franquia_NBA_Favorito : 0);
                        setAtivo(usu.ativo);
                        setResidenciaExterior(usu.residencia_Exterior);

                        setAdministrador(usu.administrador);
                        setDescontoComissario(usu.desconto_Comissario);
                        setIndicacao(usu.indicacao);    
                        const tempoCadastro = dayjs().diff(usu.dtCriacao, "day");                    
                        setPodeIndicar(tempoCadastro <= 30);

                        setCodigoUsuarioIndicacao(usu.codigo_Usuario_Indicacao);
                        carregarCidade(usu.endereco?.codEstado ? usu.endereco?.codEstado : 0);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        setIsLoading(false);
                        if (errors.response.status === 401) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível carregar os dados da usuário! Favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar("");
                    });
            }
            else {
                formRef.current?.reset();
                setShowImagemPerfil("../../semimagem.png");
            }
        }
        fetchData();
    }, [id]);


    const carregarLigasDoUsuario = async (codigoUsuario: number) =>{
          await LigaService.getAllPorCodigoUsuario(codigoUsuario)
                .then((result) => {
                    const lst = result.data.dado;
                    let listaDrop: ILstLiga[] = lst.map(l => ({ codigo: l.codigo, label: l.nome }));
                    setLstLiga(listaDrop);
                })
                .catch((errors) => {
                    if (errors.response.data.statusHTTP === 401) {
                        setShowModalMensagem(true);
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                });
    }
    const carregarCidade = async (codigoEstado: number) => {
        setCodEstado(codigoEstado);
        await CidadeService.getByIdEstado(codigoEstado)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                const cid = result.dado;
                setOpcoesCidades(cid.sort((a, b) => a.nome > b.nome ? 1 : -1)
                    .map(cid => ({ codigo: cid.codigo, label: cid.nome })));

            })
            .catch((errors) => {
                setRemoveLoading(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível carregar os dados da cidade do usuário! Favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }
    const dados = formRef?.current?.getData();


    //#region Validação de campos obrigatórios

    const nomeRef = useRef<null | HTMLElement>(null);
    const [possuiErrors, setPossuiErrors] = useState(false);

    const [errors, setErrors] = useState({
        error: false,
        nomeRef: "",
        sobreNomeRef: "",
        cgcCnpjRef: "",
        emailRef: "",
        showImagemPerfil: "",
        codPaisRef: "Campo país é obrigatório",
        codEstadoRef: "",
        codCidadeRef: "",
        mensagem: "",
        mensagemPais: "",
        mensagemEstado: "",
        mensagemCidade: "",
        mensagemLigaFavorita: "",
        codigoLigaFavoritaRef: "",
    });

    const handleSave = async (dados: IDetalheUsuario) => {
        setRemoveLoading(false);

        dados.codTema = themeName === "dark" ? 2 : 1;
        dados.cgcCnpj = residenciaExterior ? null : cpfCnpj ?? null;
        dados.residencia_Exterior = residenciaExterior;
        dados.documento = documento ?? null;
        dados.celular = dados.celular !== undefined ? dados.celular.replace("-", "") : dados.celular;
        dados.desconto_Comissario = descontoComissario;
        dados.desconto_Indicacao = indicacao;
        dados.codigo_Usuario_Indicacao = indicacao ? codigoUsuarioIndicacao : null;

        dados = {
            ...dados, "endereco": {
                ...dados.endereco,
                cep: cep.replace("-", ""),
                codPais: codPais,
                codCidade: codCidade,
                codEstado: codEstado
            },
            codigo_Franquia_NBA_Favorito: codigoFranquiaNBA === 0 ? null : codigoFranquiaNBA,
            codigo_Liga_Favorito: codigo_Liga_Favorito === 0 ? null : codigo_Liga_Favorito,
            codigo_Time_Futebol_Favorito: codigoTimeFutebolFavorito === 0 ? null : codigoTimeFutebolFavorito
        }

        if (imagemPerfil !== null && imagemPerfil !== "" && imagemPerfil !== dados.imagemPerfil) {
            const respImg = await UsuarioService.upLoadImage(imagemPerfil);
            if (respImg.data.statusHTTP === 200) {
                dados = { ...dados, imagemPerfil: respImg.data.dado.nome }
                setCaminhoImagem(respImg.data.dado.caminho);
                CookieService.set("imagem_Perfil", respImg.data.dado.caminho, {})
                alterouFoto = true;
            }
            else {
                setMensagem("Não foi possível salvar dos dados. Favor entrar em contato com a TI");
            }
        }

        // if(dados.endereco.codCidade === 0){
        //     setErrors({
        //         error: true,
        //         codCidadeRef: "Favor informar a cidade!"
        //     })
        // }

        try {
            await formValidationSchema.validate(dados, {
                abortEarly: false,
            }).then((dadosValidados) => {
                if (id === 'novo') {
                    UsuarioService.create(dadosValidados)
                        .then((result) => {
                            setIsLoading(false);
                            setRemoveLoading(true);
                            setShowModalMensagem(true);
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "success",
                                mensagem: "Registro cadastrado com sucesso!",
                                display: "none",
                                titulo: "Atenção"
                            });

                            //const updatedUser = { ...user, dados_Incompletos: false };
                            setCookie('dados_Incompletos', false);

                            if (isSaveAndClose()) {
                                setRedirecionar("/adm/usuarios");
                            } else {
                                setRedirecionar(`/usuario/usuarios/detalhe/${result}`);
                            }
                        })
                        .catch((errors) => {
                            setRemoveLoading(true);
                            setShowModalMensagem(true);
                            if (errors.response.status === 401) {
                                setDadosModal({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível criar a liga! Favor entrar em contato com a TI.",
                                display: "none",
                                titulo: "Atenção"
                            });
                        });
                } else {

                    const resultCrypt = UtilidadeService.decrypt(id);
                    if (resultCrypt === "" || resultCrypt === undefined) {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        setIsLoading(false);

                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Dados inválidos! ",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                    UsuarioService.updateById(Number(resultCrypt), dadosValidados)
                        .then((result) => {
                            setIsLoading(false);
                            setRemoveLoading(true);
                            setShowModalMensagem(true);
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "success",
                                mensagem: "Registro cadastrado com sucesso!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            //const updatedUser = { ...user, dados_Incompletos: false };
                            setCookie('dados_Incompletos', false);
                            if (isSaveAndClose()) {
                                setRedirecionar(`/adm/usuarios`);
                            }
                            setRedirecionar("");
                        })
                        .catch((errors) => {
                            setRemoveLoading(true);
                            setShowModalMensagem(true);
                            if (errors.response !== undefined) {

                                if (errors.response.status === 401) {
                                    setDadosModal({
                                        acao: true,
                                        label: "",
                                        tipo: "info",
                                        mensagem: "Sessão expirada!",
                                        display: "none",
                                        titulo: "Atenção"
                                    });
                                    logout();
                                    setRedirecionar("0");
                                    return;
                                }
                                setDadosModal({
                                    acao: true,
                                    label: "",
                                    tipo: "error",
                                    mensagem: errors.response !== undefined && errors.response.data.mensagem !== undefined ? errors.response.data.mensagem : "Não foi possível salvar os dados da liga! Favor entrar em contato com a TI.",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                            }
                            else {
                                setDadosModal({
                                    acao: true,
                                    label: "",
                                    tipo: "error",
                                    mensagem: "Não foi possível salvar os dados da liga! Favor entrar em contato com a TI.",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                            }
                        });
                }
                if (alterouFoto) {
                    setRedirecionar("0");
                }

            }).catch((err) => {
                setIsLoading(false);
                setRemoveLoading(true);
                if (err instanceof yup.ValidationError) {
                    const errorMessages: any = {};

                    err.inner.forEach(error => {
                        console.log(error.path);
                        if (error.path) {
                            errors.error = true;
                            if (error.path === "endereco.codPais") {
                                errors.mensagemPais = error.message;
                            }
                            else if (error.path === "endereco.codEstado") {
                                errors.mensagemEstado = error.message;
                            }
                            else if (error.path === "endereco.codCidade") {
                                errors.mensagemCidade = error.message;
                            }
                            else if (error.path === "codigo_Liga_Favorito") {
                                errors.mensagemLigaFavorita = error.message;
                            }
                            else if (error.path === "cgcCnpj" && !residenciaExterior) {
                                errors.cgcCnpjRef = error.message;
                            }

                            errorMessages[error.path] = error.message;
                        }
                    })
                    formRef.current?.setErrors(errorMessages);
                }
                else {
                    setShowModalMensagem(true);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível salvar os dados de usuário. Favor entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                }
            });
        }
        catch (err) {
            if (err instanceof yup.ValidationError) {
                const errorMessages: any = {};

                err.inner.forEach(error => {
                    if (error.path) {
                        errorMessages[error.path] = error.message;
                    }
                })
                formRef.current?.setErrors(errorMessages);
            }
            else {
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível salvar os dados de usuário. Favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });

            }
        }
    }

    const handleDelete = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            UsuarioService.deleteById(id)
                .then((result) => {
                    setRemoveLoading(true);
                    setShowModalMensagem(true);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "success",
                        mensagem: "Registro cadastrado com sucesso!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar("/usuarios");
                }).catch((errors) => {
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível excluir os dados do usuário! Favor entrar em contato com a TI.", display: "none",
                        titulo: "Atenção"
                    });
                });
        }
    }

    const handleInputChangeImage = (e: ChangeEvent<HTMLInputElement>) => {


        if (e.target.files && e.target.files[0]) {
            let imageFile = e.target.files[0];
            const reader = new FileReader();
            reader.onload = x => {
                setDadosImg({
                    imageFile: imageFile,
                    Imagem: e.target.name,
                    SrcImagem: x.target ? x.target?.result : ""
                });
                setShowImagemPerfil(x.target?.result);
            };
            reader.readAsDataURL(imageFile);
            setImagemPerfil(e.target.files[0]);
            CookieService.remove("imagem_Perfil");
        }
        else {
            setDadosImg({
                imageFile: null,
                Imagem: "",
                SrcImagem: ""
            })
            setShowImagemPerfil(null);
            setImagemPerfil("");
        }
    };

    const toggleModalMensagem = () => {

        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }

    }

    const handleRedirecionarTelegram = async () => {
        window.open("https://t.me/FantasyGM_bot", "_black");
    }

    const zipCodeMask = (value: any) => {
        if (!value) return ""
        value = value.replace(/\D/g, '')
        value = value.replace(/(\d{5})(\d)/, '$1-$2')
        return value
    }

    // const handlePesquisaCEP = async (e: { target: { name: string; value: any; }; }) => {
    //     let { value, name } = e.target;
    //     value = zipCodeMask(value);
    //     setCep(value);
    //     if (value.length >= 9) {
    //         let val = value.trim().replace("-", "").length;
    //         setIsLoading(true);
    //         setRemoveLoading(false);

    //         if (val === 8) {
    //             if (name === "endereco.cep") {
    //                 const response = await UtilidadeService.getEnderecoByCep(value);
    //                 if (!response.erro) {
    //                     let estado = ufs.find((e) => e.sigla === response.uf);
    //                     setCodEstado(ufs !== null && estado !== null && estado !== undefined ? Number(estado.codigo) : 0);
    //                     let lstCidades: IDetalheCidade[] = [];
    //                     await UtilidadeService.getCidadesPorCodigoEstado(Number(estado?.codigo))
    //                         .then((result) => {
    //                             setIsLoading(false);
    //                             lstCidades = result.dado;
    //                             setOpcoesCidades(lstCidades.sort((a, b) => a.nome > b.nome ? 1 : -1)
    //                                 .map(cid => ({ codigo: cid.codigo, label: cid.nome, descricao: cid.sigla })));
    //                         });

    //                     let cidade = lstCidades !== undefined && lstCidades.filter((e) => e.nome.toLowerCase() === response.localidade.toLowerCase()) !== null ? lstCidades.find((e) => e.nome.toLowerCase() === response.localidade.toLowerCase()) : null;
    //                     setCodCidade(cidade !== null && cidade !== undefined ? cidade.codigo : 0);
    //                     setValue('endereco.codEstado', estado !== undefined ? Number(estado.codigo) : 0, { shouldValidate: true });
    //                     setValue('endereco.codCidade', cidade !== null && cidade !== undefined ? Number(cidade.codigo) : 0, { shouldValidate: true });
    //                     setValue('endereco.cep', response.cep, { shouldValidate: true });
    //                     setValue('endereco.logradouro', response.logradouro, { shouldValidate: true });
    //                     setValue('endereco.bairro', response.bairro, { shouldValidate: true });
    //                     setEndereco(endereco);
    //                 }
    //                 else {

    //                     setValue('endereco.codEstado', 0, { shouldValidate: true });
    //                     setValue('endereco.codCidade', 0, { shouldValidate: true });
    //                     setValue('endereco.cep', "", { shouldValidate: true });
    //                     setValue('endereco.logradouro', "", { shouldValidate: true });
    //                     setValue('endereco.bairro', "", { shouldValidate: true });

    //                     setShowModalMensagem(true);

    //                     setDadosModalMensagem({
    //                         acao: true,
    //                         label: "",
    //                         tipo: "info",
    //                         mensagem: "Não foi possível carregar os dados para o CEP informado!",
    //                         display: "none",
    //                         titulo: "Atenção"
    //                     });
    //                     //setRedirecionar("0");

    //                 }
    //             } else {
    //                 console.log(val)
    //             }
    //         }
    //     }
    //     setIsLoading(false);
    //     setRemoveLoading(true);
    // }

    return (
        <LayoutBaseDePagina titulo={id !== "novo" ? nome : "Novo cadastro de usuário"}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={id !== "novo" && adm === true}
                    mostrarBotaoNovo={id !== "novo" && adm === true}
                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEFechar={saveAndClose}
                    aoClicarEmApagar={() => handleDelete(Number(id))}
                    aoClicarEmNovo={() => navigate("/usuarios/detalhe/novo")}
                    aoClicarEmVoltar={() => user.administrador === true ? navigate("/adm/usuarios") : navigate("/dashboard")}
                />
            }
        >
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" padding={2} spacing={2}>
                        {!removeLoading && <Loading />}
                        <Grid >
                            <Typography variant="h6">Geral</Typography>
                            <hr />
                        </Grid>
                        <Grid container direction="row" spacing={2}>
                            {edicao && (
                                <Grid size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
                                    <VTextField
                                        fullWidth
                                        placeholder="Codigo"
                                        name="codigo"
                                        disabled
                                        label="Código"
                                    />
                                </Grid>
                            )}
                            <Grid size={{ xs: 12, sm: 3, md: 3 }} >
                                <CheckBox
                                    required
                                    isExternalLoading={isLoading}
                                    name="residenciaExterior"
                                    label="Residência Exterior"
                                    checked={residenciaExterior}
                                    onChange={(e) => { setResidenciaExterior(e.target.checked); setDocumento(""); setCpfCnpj(""); }}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 3, md: 2 }} >
                                <CheckBox
                                    required
                                    isExternalLoading={isLoading}
                                    name="ativo"
                                    label="Ativo"
                                    checked={ativo}
                                    disabled={!adm}
                                    onChange={(e) => setAtivo(e.target.checked)}
                                />
                            </Grid>
                            {adm && <Grid size={{ xs: 12, sm: 3, md: 2 }} >
                                <CheckBox
                                    required
                                    isExternalLoading={isLoading}
                                    name="administrador"
                                    label="Administrador"
                                    checked={administrador}
                                    onChange={(e) => setAdministrador(e.target.checked)}
                                />
                            </Grid>
                            }
                            <Grid size={{ xs: 12, sm: 3, md: 3 }} display={"flex"} justifyContent="center" justifyItems="center" >
                                <Button
                                    color="primary"
                                    variant="contained"
                                    disableElevation
                                    onClick={() => handleRedirecionarTelegram()}
                                    sx={{ backgroundColor: "#24A1DE", height: "38px" }}
                                    endIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 12 : 26 }}>telegram</Icon>}>
                                    <span style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }} >{UtilidadeService.isMobile() ? "Config. Telegram" : "Configurar Telegram"}</span>
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid container direction="row" spacing={UtilidadeService.isMobile() ? 2 : 1}>
                            <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                                <VTextField
                                    required
                                    fullWidth
                                    placeholder="Nome"
                                    name="nome"
                                    disabled={isLoading}
                                    label="Nome"
                                    onChange={e => { setNome(e.target.value); setErrors({ ...errors, nomeRef: "" }) }}
                                    ref={nomeRef as any}
                                />
                                <Grid size={{ xs: 12, sm: 12, md: 12 }} height="24px">
                                    {errors.nomeRef && <span style={{ fontSize: "13px", color: "red" }}>{errors.nomeRef}</span>}
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 3 }} sx={{ paddingBottom: UtilidadeService.isMobile() ? 1 : 0 }}>
                                <VTextField
                                    fullWidth
                                    size={"small"}
                                    placeholder="Sobrenome"
                                    name="sobrenome"
                                    disabled={isLoading}
                                    label="Sobrenome"
                                    onChange={e => { setErrors({ ...errors, sobreNomeRef: "" }) }}
                                />
                                {/* <Grid  size={{xs:12, sm:12, md:12}} height="24px">
                                    {errors.sobreNomeRef && <span style={{ fontSize: "13px", color: "red" }}>{errors.sobreNomeRef}</span>}
                                </Grid> */}
                            </Grid>
                            {residenciaExterior ? (
                                <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                                    <TextField
                                        label="Documento"
                                        fullWidth
                                        size={"small"}
                                        color="primary"
                                        name="documento"
                                        disabled={isLoading}
                                        placeholder="Documento"
                                        value={documento}
                                        onChange={(e: any) => { setDocumento(e.target.value); }}
                                        slotProps={{
                                            htmlInput: {
                                                maxLength: 9
                                            },
                                            inputLabel: {
                                                shrink: true,
                                            },
                                        }} />
                                </Grid>
                            )
                                : (
                                    <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                                        <TextField
                                            label="CPF/CNPJ"
                                            required={!residenciaExterior}
                                            fullWidth
                                            error={!!errors.cgcCnpjRef}
                                            helperText={errors.cgcCnpjRef}
                                            size={"small"}
                                            color="primary"
                                            name="cgcCnpj"
                                            disabled={isLoading}
                                            placeholder="CPF/CNPJ"
                                            value={cpfCnpj}
                                            onChange={(e: any) => {
                                                e.target.value.length > 14 ? setCpfCnpj(maskCNPJEvent(e)) : setCpfCnpj(maskCPFEvent(e));
                                                setErrors({ ...errors, cgcCnpjRef: "" })
                                            }}
                                            slotProps={{
                                                htmlInput: {
                                                    maxLength: 9
                                                },
                                                inputLabel: {
                                                    shrink: true,
                                                },
                                            }} />

                                    </Grid>
                                )
                            }
                            <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                                <VTextField
                                    required
                                    fullWidth
                                    placeholder="E-mail"
                                    name="email"
                                    disabled={isLoading}
                                    label="E-mail"
                                    onChange={e => { setErrors({ ...errors, emailRef: "" }) }}
                                />
                                <Grid size={{ xs: 12, sm: 12, md: 3 }} height="24px">
                                    {errors.emailRef && <span style={{ fontSize: "13px", color: "red" }}>{errors.emailRef}</span>}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container direction="row" spacing={UtilidadeService.isMobile() ? 2 : 1}>
                            <Grid size={{ xs: 12, sm: 6, md: 2, lg: 1 }} >
                                <VInputCurrency
                                    required
                                    fullWidth
                                    placeholder="DddCel"
                                    name='dddCel'
                                    disabled={isLoading}
                                    label="DddCel"
                                    typeMask="dddCel"
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 3, xl: 3 }}>
                                <VInputCurrency
                                    required
                                    fullWidth
                                    placeholder="Celular"
                                    name='celular'
                                    disabled={isLoading}
                                    label="Celular"
                                    typeMask="celular"
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }}>
                                <VTextFieldDatas
                                    fullWidth
                                    required
                                    placeholder="Data Nascimento"
                                    type="date"
                                    name="dtNascimento"
                                    disabled={isLoading}
                                    label="Data Nascimento"
                                    slotProps={{
                                        inputLabel: {
                                            shrink: edicao ? true : undefined,
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                                <RadioGroup
                                    isExternalLoading={isLoading}
                                    items={sexoItens}
                                    name="sexo"
                                    label="Sexo"
                                />
                            </Grid>
                            {podeIndicar && (
                                <>
                                    <Grid size={{ xs: 12, sm: 2, md: 2 }} >

                                        <CheckBox
                                            isExternalLoading={isLoading}
                                            name="desconto_Indicacao"
                                            label="Indicação"
                                            checked={indicacao}
                                            onChange={(e) => setIndicacao(e.target.checked)}
                                        />
                                    </Grid>
                                    {indicacao &&
                                        <Grid size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                placeholder="Código Indicação"
                                                name="codigoUsuarioIndicacao"
                                                label="Código Indicação"
                                                value={codigoUsuarioIndicacao}
                                                onChange={(e) => setCodigoUsuarioIndicacao(Number(e.target.value))}
                                            />
                                        </Grid>
                                    }
                                </>
                            )}
                            {adm && <Grid size={{ xs: 12, sm: 6, md: 6 }} >
                                <CheckBox
                                    isExternalLoading={isLoading}
                                    name="desconto_Comissario"
                                    label="Desconto  Comissário"
                                    checked={descontoComissario}
                                    onChange={(e) => setDescontoComissario(e.target.checked)}
                                />
                            </Grid>
                            }
                        </Grid>
                        <Grid container direction="row" spacing={2} display="none">
                            <Grid size={{ xs: 12, sm: 12, md: 6 }} display="none">
                                <VTextField
                                    fullWidth
                                    placeholder="Tipo"
                                    name="tipo"
                                    disabled={isLoading}
                                    label="Tipo"
                                    value="PF" />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 4 }}>
                                <VTextField
                                    placeholder="Usuário"
                                    type="number"
                                    name="codUsuCriacao"
                                    disabled={isLoading}
                                    label="Usuário"
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 4 }}>
                                <VTextField
                                    placeholder="Sistema"
                                    type="number"
                                    name="codSistema"
                                    disabled={isLoading}
                                    label="Sistema"
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 4 }}>
                                <VTextField
                                    placeholder="Tema"
                                    type="number"
                                    name="codTema"
                                    disabled={isLoading}
                                    label="Tema"
                                />
                            </Grid>
                        </Grid>
                        <Grid >
                            <Typography variant="h6">Endereço</Typography>
                            <hr />
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} spacing={2}>
                            <VScope key="1" path={`endereco`}>
                                {edicao && (
                                    <Grid container direction="row" spacing={2} display="none">
                                        <Grid size={{ xs: 12, sm: 12, md: 3 }} >
                                            <VTextField
                                                fullWidth
                                                placeholder="Codigo"
                                                name="codigo"
                                                disabled
                                                label="Código"
                                            />
                                        </Grid>
                                    </Grid>)}
                                <Grid container size={{ xs: 12, sm: 12 }} direction="row" spacing={2}>
                                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                        <TextField
                                            label="CEP"
                                            required
                                            size={"small"}
                                            color="primary"
                                            name="cep"
                                            value={zipCodeMask(cep)}
                                            onChange={(e) => {
                                                setCep(e.target.value)
                                                //handlePesquisaCEP(e); 
                                            }}
                                            slotProps={{
                                                htmlInput: {
                                                    maxLength: 9
                                                },
                                                inputLabel: {
                                                    shrink: true,
                                                },
                                            }}

                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                                        <VTextField
                                            required
                                            fullWidth
                                            placeholder="Tipo Logradouro"
                                            name='tipoLogradouro'
                                            disabled={isLoading}
                                            label="Tipo Logradouro"
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                                        <VTextField
                                            required
                                            fullWidth
                                            name='logradouro'
                                            disabled={isLoading}
                                            label="Logradouro"
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                        <VTextField
                                            required
                                            fullWidth
                                            placeholder="Numero"
                                            name='numero'
                                            disabled={isLoading}
                                            label="Número"
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                        <VTextField
                                            fullWidth
                                            placeholder="Complemento"
                                            name='complemento'
                                            disabled={isLoading}
                                            label="Complemento"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container size={{ xs: 12, sm: 12 }} direction="row" spacing={2}>
                                    <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                                        <VTextField
                                            required
                                            fullWidth
                                            placeholder="Bairro"
                                            name='bairro'
                                            disabled={isLoading}
                                            label="Bairro"
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                                        <FormControl fullWidth >
                                            <InputLabel id="demo-simple-select-label">País</InputLabel>
                                            <Select
                                                required
                                                size={"small"}
                                                name="codPais"
                                                variant="outlined"
                                                value={codPais}
                                                onChange={(e) => { setCodPais(Number(e.target.value)); setErrors({ ...errors, mensagemPais: "" }) }}
                                                label="País"
                                                error={errors.mensagemPais.length > 0}
                                            >
                                                <MenuItem value={0}>Selecione</MenuItem>
                                                {
                                                    opcoesPais.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                }

                                            </Select>
                                            {errors.error && <p style={{ color: 'red' }}>{errors.mensagemPais}</p>}
                                        </FormControl >
                                        {/* <Grid  size={{xs:12, sm:12, md:12}} height="24px">
                                            {errors.codPaisRef && <span style={{ fontSize: "13px", color: "red" }}>{errors.codPaisRef}</span>}
                                        </Grid> */}
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                                        <FormControl fullWidth >
                                            <InputLabel id="demo-simple-select-label">Estado</InputLabel>
                                            <Select
                                                required
                                                size={"small"}
                                                label="Estado"
                                                name="codEstado"
                                                variant="outlined"
                                                value={codEstado}
                                                error={errors.mensagemEstado.length > 0}
                                                onChange={(e) => { setCodEstado(Number(e.target.value)); carregarCidade(Number(e.target.value)); setErrors({ ...errors, mensagemEstado: "" }) }}
                                            >
                                                <MenuItem value={0}>Selecione</MenuItem>
                                                {
                                                    opcoesEstado.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                }

                                            </Select>
                                            {errors.error && <p style={{ color: 'red' }}>{errors.mensagemEstado}</p>}
                                        </FormControl >

                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                                        <FormControl fullWidth >
                                            <InputLabel id="demo-simple-select-label">Cidade</InputLabel>
                                            <Select
                                                required
                                                size={"small"}
                                                label="Cidade"
                                                name="codCidade"
                                                variant="outlined"
                                                value={codCidade}
                                                error={errors.mensagemCidade.length > 0}
                                                onChange={(e) => { setCodCidade(Number(e.target.value)); setErrors({ ...errors, mensagemCidade: "" }) }}
                                            >
                                                <MenuItem value={0}>Selecione</MenuItem>
                                                {
                                                    opcoesCidades.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                }

                                            </Select>
                                            {errors.error && <p style={{ color: 'red' }}>{errors.mensagemCidade}</p>}
                                        </FormControl >
                                    </Grid>
                                </Grid>
                            </VScope>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }} >
                            <Typography variant="h6">Outras Informações</Typography>
                            <hr />
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} spacing={2}>
                            <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                                <FormControl fullWidth >
                                    <InputLabel id="demo-simple-select-label">Liga Favorita </InputLabel>
                                    <Select                                        
                                        size={"small"}
                                        label="Liga Favorita"
                                        name="codigo_Liga_Favorito"
                                        variant="outlined"
                                        value={codigo_Liga_Favorito}
                                        error={errors.mensagemLigaFavorita.length > 0}
                                        onChange={(e) => { setCodigo_Liga_Favorito(Number(e.target.value)); setErrors({ ...errors, mensagemLigaFavorita: "" }) }}
                                    >
                                        <MenuItem value={0}>Selecione</MenuItem>
                                        {
                                            lstLiga.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                        }

                                    </Select>
                                    {/* {errors.error && <p style={{ color: 'red' }}>{errors.mensagemLigaFavorita}</p>} */}
                                </FormControl >
                            </Grid>
                            <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                                <FormControl fullWidth >
                                    <InputLabel id="demo-simple-select-label">Franquia NBA </InputLabel>
                                    <Select
                                        label="Franquia NBA"
                                        name="codEstado"
                                        size={"small"}
                                        variant="outlined"
                                        value={codigoFranquiaNBA}
                                        onChange={(e) => { setCodigoFranquiaNBA(Number(e.target.value)); }}
                                    >
                                        <MenuItem value={0}>Selecione</MenuItem>
                                        {
                                            lstFranquiasNBA.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                        }

                                    </Select>
                                </FormControl >
                            </Grid>
                            <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                                <FormControl fullWidth >
                                    <InputLabel id="demo-simple-select-label">Time Futebol </InputLabel>
                                    <Select
                                        label="Time Futebol"
                                        size={"small"}
                                        name="codigoTimeFutebolFavorito"
                                        variant="outlined"
                                        value={codigoTimeFutebolFavorito}
                                        onChange={(e) => { setCodigoTimeFutebolFavorito(Number(e.target.value)); }}
                                    >
                                        <MenuItem value={0}>Selecione</MenuItem>
                                        {
                                            opcoesTimeFavorito.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                        }

                                    </Select>
                                </FormControl >
                            </Grid>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <Typography variant="h6">Dados de Acesso</Typography>
                            <hr />
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} spacing={2}>
                            <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                                <VTextField
                                    required
                                    fullWidth
                                    placeholder="Login"
                                    name="login"
                                    disabled={isLoading}
                                    label="Login"
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                                <VTextField
                                    required
                                    fullWidth
                                    placeholder="Senha"
                                    type="password"
                                    name="senha"
                                    disabled={isLoading}
                                    label="Senha"
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                                <VTextField
                                    fullWidth
                                    placeholder="Confirmar Senha"
                                    type="password"
                                    name="confirmarSenha"
                                    // value={confirmarSenha}
                                    // onChange={(e) => setConfirmarSenha(e.target.value)}
                                    disabled={isLoading}
                                    label="Confirmar Senha"
                                />
                            </Grid>
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} marginTop={2}>
                            <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                <Typography variant="h6">Foto Perfil</Typography>
                                <hr />
                            </Grid>
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }}>
                            <Grid container size={{ xs: 12, sm: 12 }} margin={1} spacing={1} display="flex" justifyItems="center" alignItems="end" >
                                <Grid size={{ xs: 12, sm: 12 }} >
                                    <VInput
                                        required
                                        type="file"
                                        slotProps={{
                                            htmlInput: { accept: "image/*" }
                                        }}
                                        className="classes.input"
                                        name="imagem"
                                        onChange={(e: ChangeEvent<HTMLInputElement>) => { handleInputChangeImage(e); setErrors({ ...errors, showImagemPerfil: "" }) }}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 3 }} display="flex" justifyContent="center">
                                    <img src={showImagemPerfil} alt="SrcImagem" width="200" height="200" />
                                    {errors.showImagemPerfil && <span style={{ fontSize: "13px", color: "red" }}>{errors.showImagemPerfil}</span>}
                                </Grid>

                                {edicao && <Grid size={{ xs: 12, sm: 12 }} display="none" >
                                    <VInput
                                        type="text"
                                        name="imagemPerfil"
                                    />
                                </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina >
    );
};